export default function getStyleProp(element, prop) {
  return window.getComputedStyle
    ? window.getComputedStyle(element, null).getPropertyValue(prop)
    : '';
}
